
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-charts/radial-bars",
      function () {
        return require("private-next-pages/x/react-charts/radial-bars.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-charts/radial-bars"])
      });
    }
  